<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <ReportModal></ReportModal>
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-main id="content">
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
            <router-view></router-view>
          </div>
          <!-- App Footer -->
          <v-footer height="auto" class="pa-4 app-footer">
            <img src="@/assets/logo_footer.png" height="20" alt="logo" />
          </v-footer>
        </v-main>
        <!-- Go to top -->
        <app-dialog />
        <app-snack-bar />
        <app-fab></app-fab>
      </v-app>
    </template>
    <template v-else>
      <router-view v-slot="{ Component, route }">
        <transition>
          <keep-alive>
            <component :is="Component" :key="route.fullPath" />
          </keep-alive>
        </transition>
      </router-view>
    </template>
  </div>
</template>

<script>
import { useTheme } from 'vuetify';
import AppDrawer from '@/components/AppDrawer';
import AppToolbar from '@/components/AppToolbar';
import AppFab from '@/components/AppFab';
import PageHeader from '@/components/PageHeader';
import AppEvents from './event';
import ReportModal from './components/job/reports/ReportModal';
import AppDialog from '@/components/dialog/AppDialog.vue';
import AppSnackBar from '@/components/AppSnackBar.vue';

export default {
  components: {
    AppSnackBar,
    AppDialog,
    ReportModal,
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader,
  },
  data: () => ({
    appEventHandlers: [],
  }),
  setup() {
    return { theme: useTheme() };
  },
  created() {
    // this.$http.interceptors.response.use(undefined, function(err) {
    //   return new Promise(function(resolve) {
    //     Vue.store.dispatch("auth/logout");
    //     window.location.reload();
    //   });
    // });

    this.appEventHandlers = AppEvents.map(item => ({
      name: item.name,
      callback: item.callback.bind(this),
    }));
    this.appEventHandlers.forEach(({ name, callback }) => this.$bus.on(name, callback));
  },
  mounted() {
    this.theme.change('light');
  },
  beforeUnmount() {
    this.appEventHandlers.forEach(({ name, callback }) => this.$bus.off(name, callback));
  },
};
</script>

<style lang="stylus" scoped>
.app{
  background-color:#EEEEEE;
}

.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.info-message {
  display: flex;
  flex-direction: row;
  background-color: lightyellow;
  width: 100%;
  padding: 5px;
  vertical-align: center;
}

.info-message > span {
  margin: auto 10px;
  text-align: center;
  width: 100%;
}

.page-wrapper {
  //min-height: calc(100vh - 64px - 50px - 60px);
  flex: 1 1 100%;
}

.app-footer {
  background-color: unset;
  //align-self: flex-end;
}

@media print {
  #appDrawer{
    display: none;
  }
  .v-main {
    padding: 0 !important;
  }
  .toolbar{
    display: none;
  }
}
</style>
